// extracted by mini-css-extract-plugin
export default {"lcdbackground":"LCDComponent_lcdbackground__QGPYI","lcdline":"LCDComponent_lcdline__cYcPC","lcdblock":"LCDComponent_lcdblock__g0MV3"};